// node modules
import React from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
// modules
import { history } from '../../service';

export const AuthorizedRouter: React.FC<AuthorizedRouterProps> = observer(
  ({ appRoutes }) => {
    const { paths, component, rootPath } = appRoutes;

    return (
      <Router history={history}>
        <Switch>
          <Route
            exact
            path={paths}
            component={component}
          />

          {rootPath && <Redirect to={rootPath} />}
        </Switch>
      </Router>
    );
  },
);

export const AppRouter: React.FC = ({ children }) => (
  <Router history={history}>{children}</Router>
);
